<template>
  <div>
   <div class="row bg-cat" :style="'background: url(' + bg() + '); margin: 0; color:#fff; min-height:100vh; padding: 30px 0 50px 0;'">
      <div class="container bgw">
        <div class="row">
          <div class="col-md-12" v-if="state.shippings.length > 0 || state.pickups.length > 0">
            <h1 class="text-center">Cпособы доставки</h1>
          </div>

          <div class="col-md-12" v-if="state.pickups.length > 0">
            <h2 class="text-center">Самовывоз</h2>
            <div class="col-md-12 text-left" v-for="pickup in state.pickups">
             <h3>{{ pickup.name }}</h3>
              <p>{{ pickup.descr }}</p>
            </div>
          </div>

          <div class="col-md-12" v-if="state.shippings.length > 0">
            <h2 class="text-center">Доставка</h2>
            <div class="col-md-12 text-left" v-for="shipping in state.shippings">
              <h3>{{ shipping.name }}</h3>
              <p>{{ shipping.descr }}</p>
            </div>
          </div>

          <div class="col-md-12" v-if="state.payments.length > 0">
            <h1 class="text-center">Способы оплаты</h1>
            <div class="col-md-12 text-left" v-for="payment in state.payments">
              <h3>{{ payment.name }}</h3>
              <p>{{ payment.descr }}</p>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      state() {
        return this.$store.state
      }
    },
    methods: {
      bg() {
        var vm = this;
        return vm.state.config.url + vm.state.config.img_url + vm.state.config.id + '/' + vm.state.info.background;
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/DeliveryAndPayment/DeliveryAndPayment.vue